var constants = require('../constants');
var initialState = require('../../initialState');

var trials = function(state, action) {
  var newstate = Object.assign({},state);
  switch (action.type) {
	  case constants.REQUEST_TRIALS:
	  	newstate.isFetching = true;
	  	return newstate;
	  case constants.RECEIVE_TRIALS:
	  	newstate.isFetching = false;
      newstate.totalCount = action.trialsData.totalCount;
	  	newstate.data = action.trialsData.trialList;
	  	return newstate;
	  default: return state || initialState.trials;
  }
}

module.exports = trials;


// WEBPACK FOOTER //
// ./src/common/modules/trials/reducers/trials.js